import { render, staticRenderFns } from "./CardArtefato.vue?vue&type=template&id=60e888d9&scoped=true"
import script from "./CardArtefato.vue?vue&type=script&lang=js"
export * from "./CardArtefato.vue?vue&type=script&lang=js"
import style0 from "./CardArtefato.vue?vue&type=style&index=0&id=60e888d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e888d9",
  null
  
)

export default component.exports